import type { FC } from 'react';
import { cn } from '@/shared/lib/utils';

type Props = {
  className?: string;
};

export const ProductLogo: FC<Props> = ({ className }) => {
  return <img src="/product-logo.svg" alt="WiseVine BnS" className={cn('h-5', className)} />;
};
